export namespace AppConstants {
    export const projectDetails = "project-details";
    export const wldDomainSizing = "wld-domain-sizing";
    export const mgntDomainSizing = "mgnt-domain-sizing";
    export const outputRecommendation = "output-recomm";
    export const DOMAIN_BROADCOM_NET = "broadcom.net";
    export const vSAN_ESA = "ESA";
    export const vSAN_OSA = "OSA";
    export const PROJECT_STATUS_COMPLETED = "COMPLETED";
    export const PROJECT_STATUS_INPROGRESS = "IN-PROGRESS";
    export const PROJECT_STATUS_NEW = "NEW";

    // Sentinel selectedProfileCode value marking the "Selected ReadyNode" 4th card as the active
    // selection - can never collide with a real tier profileCode (those are backend-provided
    // vSAN-HCI-SM/MED/LRG-style strings).
    export const SELECTED_READYNODE_PROFILE_CODE = "SELECTED_READYNODE";

    // Literal requirementsId the management-domain sizing request always uses (there's only ever
    // one management domain per project, so no per-project/per-domain id is needed). Single source
    // of truth so callers that need to match a recalculation response back to this requirement
    // (e.g. ReadyNodeRecalculationService) never drift from what sizing-request.adapter.ts sends.
    export const MANAGEMENT_DOMAIN_REQUIREMENT_ID = "MANAGEMENT_DOMAIN_REQUIREMENT_ID";

    export const STORAGE_TYPES = [
        {
            name: 'vSAN Storage',
            code: 'VSAN'
        },
        // {
        //     name: 'External Storage',
        //     code: 'external'
        // }
    ];

    export const vSAN_ARCHITECTURES = [
        {
            name: "vSAN ESA",
            code: "ESA"
        },
        {
            name: "vSAN OSA",
            code: "OSA"
        }
    ];

    export const PROFILE_MODE = [
        {
            name: "All Flash",
            code: "AF"
        },
        {
            name: "Hybrid",
            code: "HY"
        }
    ];

    export const WORKLOADS = [
        {
            name: "General Purpose",
            code: "GPW"
        },
        {
            name: "Databases",
            code: "DBW"
        },
        {
            name: "VDI",
            code: "VDI"
        }
    ];

    export const DBW_SUPPORTED_WORKLOAD_TYPES = [
        {
            name: "Oracle",
            code: "ORA"
        },
        {
            name: "Microsoft SQL Server",
            code: "SQL"
        }
    ];

    export const GPW_SUPPORTED_WORKLOAD_TYPES = [{
        name: "General Purpose VMs",
        code: "GVM"
    }];

    export const VDI_SUPPORTED_WORKLOAD_TYPES = [
        {
            name: "Full Clone",
            code: "FCL"
        },
        {
            name: "Linked Clone",
            code: "LCL"
        },
        {
            name: "Instant Clone",
            code: "ICL"
        }
    ];

    export const CAL_LOG_KEYS = {
        cpuBound: "Cpu Bound",
        ioBound: "Io Bound",
        capacityBound: "Capacity Bound",
        memoryBound: "Memory Bound",
        hft: "Hft",
        diskLayout: "Disk Layout",
        finalRecommendation: "Final Recommendation",
        logHelp: "Log Help"
    }

    export const IO_ACCESS_PATTEN_SEQUENTIAL_IO_RATIO = {
        default: {
            value: "100% Read",
            unit: null
        },
        options: [
            {
                value: "100% Read",
                unit: null
            },
            {
                value: "100% Write",
                unit: null
            }
        ]
    };

}
